<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}品牌
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="(webItemMappingSave && formData.id == null) || (webItemMappingEdit && formData.id != null)"
                     @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  产品编码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.itemCode" clearable readonly="true">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog=true"></i>
                  </el-input>
                </td>
                <th>
                  <em class="f-red">*</em>
                  产品名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.itemName" clearable readonly="true"
                            disabled>
                    <!-- <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog=true"></i> -->
                  </el-input>
                </td>

                <th>
                  店铺名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.webShop" clearable/>
                </td>
                <th>
                  是否即时取消
                </th>
                <td>
                  <el-select v-model="formData.isCloseOrder">
                    <el-option label="否" :value="0"></el-option>
                    <el-option label="是" :value="1"></el-option>
                  </el-select>
                </td>

              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  电商平台
                </th>
                <td>
                  <el-select v-model="formData.webPlatform">
                    <el-option label="天猫" :value="1"/>
                    <el-option label="京东UE" :value="2"/>
                    <el-option label="苏宁" :value="3"/>
                    <el-option label="抖音" :value="4"/>
                    <el-option label="拼多多" :value="5"/>
                  </el-select>
                </td>
                <th>
                  电商产品编码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.webItemCode" clearable/>
                </td>

                <th>
                  电商产品名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.webItemName" clearable/>
                </td>

                <th>同步电商平台</th>
                <td v-if="formData.syncWebPlatform==1">已同步</td>
                <td v-else-if="formData.syncWebPlatform==0">未同步</td>
                <td v-else></td>
              </tr>
              <!-- <tr>
                <th>
                    产品绑定
                    </th>
                    <td>
                      <el-input id="file" v-model="formData.bindItemName" autocomplete="off" disabled="true"  clearable />
                    </td>

                    <div class="papers">
                        <el-button type="primary" class="button-sty btn_zdy2"  @click="showPreconditionDialog=true">
                          <i class="el-icon-plus"></i>
                          选取产品</el-button>
                    </div>
              </tr> -->
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>

      </div>
    </el-form>
    <preconditionDialog v-if="showPreconditionDialog" @commitSelectedRow="commitSelectedRow"
                        :visiable.sync="showPreconditionDialog" multi="true"
    />
  </div>
</template>
<script>
import {
  initVxeTable
} from '@/const/crud/admin/table';
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
import api from "@/api/projectApi";
import {mapGetters} from "vuex";

export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    Tinymce,
    preconditionDialog,
  },
  data() {
    return {
      webItemMappingSave: false,
      webItemMappingEdit: false,
      getDataUrl: '/basic/basWebitemMapping/getById',
      saveDataUrl: '/basic/basWebitemMapping/add',
      updateDataUrl: '/basic/basWebitemMapping/update',
      activeName: 'first',
      selectedRow: {id: '', name: ''},
      showPreconditionDialog: false,

      // 基本信息
      formData: {
        id: null,
        createBy: '',  // 创建人
        createTime: '',  // 创建时间
        itemId: '',  // 产品Id,关联bas_item.id
        itemCode: '',  // 产品编码,冗余字段
        itemName: '',  // 产品名称,冗余字段
        webPlatform: '',  // 电商平台：1天猫；2京东UE；3苏宁
        webItemCode: '',  // 电商产品编码
        webItemName: '',  // 电商产品名称
        webShop: '',  // 店铺名称
        bindItemName: '',  // 关联产品名bas_item.item_name,
        isCloseOrder: 0,
        syncWebPlatform: 0
      },


      radio: '1',
      showEdit: false,
      valuetype: 'model',
      textarea: '',
      //  value1: true,
      value2: false,
      value3: true,

      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',


    };
  },
  watch: {
    selectedRow: {
      handler(newVal, oldVal) {
        this.formData.itemId = newVal.id
        this.formData.itemCode = newVal.itemCode
        this.formData.itemName = newVal.itemName
        // this.inspection()
      },
      deep: true
    },

  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.webItemMappingSave = this.permissions['web_item_mapping_add']
    this.webItemMappingEdit = this.permissions['web_item_mapping_edit']
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },

  mounted() {
    this.getData();
  },

  methods: {
    inspection() {
      if (this.formData.itemCode) {
        this.$http({
          url: api.basWebitemMapping.inspectionUrl,
          method: 'post',
          data: {
            value: this.formData.itemCode,
            id: this.formData.id,
          }
        }).then(res => {
          if (!res.data.data) {
            this.$message.warning("产品编码已存在，请重新输入")
            this.formData.itemId = null
            this.formData.itemCode = null
            this.formData.itemName = null
          }
        })
      }
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: this.getDataUrl,
          method: 'post',
          data: {id: this.dataId}
        }).then(res => {
          this.formData = res.data.data
        }).catch(() => {
          this.$message.error("数据加载失败！");
        })
      }
    },

    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            this.$http({
              url: this.isEdit ? this.updateDataUrl : this.saveDataUrl,
              method: `post`,
              data: this.formData
            }).then(() => {
              this.$message.success("保存成功！");
              this.reload()
              this.$mask.close()

              // this.$emit('editViewDataUpdate')
            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！");
              this.$mask.close()

            })
          })
        }
      })
    },

    commitSelectedRow(data) {
      this.selectedRow = data
    }


  },
};

</script>
<style lang="scss" scoped>
::v-deep body .el-dialog {
  height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  height: 700px;
  overflow: hidden;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
  font-size: 14px !important;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

</style>
